var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',[_c('v-row',{attrs:{"no-gutters":""}},[_c('v-col',{attrs:{"cols":"12"}},[_c('ItemsDataTable',{ref:"itemsDataTableRef",attrs:{"loadData":_vm.loadDataFunction,"export":_vm.isExportSearch}})],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }